import React from "react";
//#region types
import { GraphConstants } from "utils/constants";
import { ChartEnums } from "models/enums";
//#endregion
//#region components
import { ChartContainer } from "components/common";
import { useInvoiceService } from "serviceHooks";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import ReportWidgetType = WintSuperkollAPIModel.ReportWidgetType;
import { ChartPeriodClickArgs } from "models/propTypes/chartProps";
//#endregion

const InvoicedAmountBarChart: React.FC = () => {
  const invoiceService = useInvoiceService();
  const labelFormatter = (label?: string) => (label ? label.substring(0, 3) : "");

  return (
    <ChartContainer
      useSkeleton={ReportWidgetType.Bar}
      chartAPIKey={GraphConstants.ChartKeys.InvoicedAmount}
      accumulatedChartAPIKey={GraphConstants.ChartKeys.AccumulatedInvoicedAmount}
      filterToAPIHandler={invoiceService.reportToAPIFilter}
      labelFormatter={labelFormatter}
      usePageFilter={false}
      useClickableChart
      yAxisTickUnit={ChartEnums.YAxisTickUnitType.Currency}
      onDataPointClickedSetFilter={(arg) => {
        const args = arg as ChartPeriodClickArgs | undefined;
        return args?.start && args?.end ? { invoiceDate: { start: args.start, end: args.end } } : {}
      }}
      onBackgroundClickedSetFilter={{ invoiceDate: undefined }}
    />
  );
};

export default InvoicedAmountBarChart;
